import formatName from 'I18n/utils/formatName';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { SuperAdminStatusTag } from '../components/common/SuperAdminStatusTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const buildApproverOption = ({
  approver,
  superAdminUserIds,
  approvedApproverIds,
  requesterOwnerId
}) => {
  const searchableText = `${approver.firstName} ${approver.lastName} ${approver.email}`;
  const formattedName = formatName({
    firstName: approver.firstName,
    lastName: approver.lastName,
    email: approver.email
  });
  const isSuperAdmin = superAdminUserIds.has(approver.activeUserId);
  return {
    text: searchableText,
    dropdownText: /*#__PURE__*/_jsxs(TFlex, {
      gap: 12,
      children: [formattedName, isSuperAdmin && /*#__PURE__*/_jsx(SuperAdminStatusTag, {})]
    }),
    buttonText: formattedName,
    value: approver.ownerId,
    help: approver.email,
    disabled: (approvedApproverIds === null || approvedApproverIds === void 0 ? void 0 : approvedApproverIds.includes(approver.ownerId)) || approver.ownerId === requesterOwnerId
  };
};